export default "__VITE_PUBLIC_ASSET__b70ab06d__"